import { BrowserModule } from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule, MatButtonModule, MatCardModule, MatTableModule, MatExpansionModule } from '@angular/material';
import { NgxJsonViewerModule } from 'ngx-json-viewer';

import { AppComponent } from './app.component';
import { AppConfigService } from './app.config';
import { routing, appRoutingProviders } from './app.routing';

import { SearchService } from './services/search';
import { FormsService } from './services/forms';
import { SearchDocusignService } from './services/search-docusign';
import { SearchSterlingService } from './services/search-sterling';

import { SearchComponent } from './components/search/search';
import { AuthGuard } from './services/auth-guard';
import { Login } from './components/login/login';
import { Forms } from './components/forms/forms';
import { DetailComponent } from './components/detail/detail';
import { SearchDocusignComponent } from './components/search-docusign/search-docusign';
import { SearchSterlingComponent } from './components/search-sterling/search-sterling';
import { SterlingDetailComponent } from './components/sterling-form/sterling-form';



@NgModule({
  declarations: [
    AppComponent, SearchComponent, Login, Forms, DetailComponent, SearchDocusignComponent, SearchSterlingComponent,
    SterlingDetailComponent
  ],
  imports: [
    BrowserModule, BrowserAnimationsModule, FormsModule, ReactiveFormsModule, HttpModule,
    routing, MatInputModule, MatButtonModule, MatCardModule, NgxJsonViewerModule, MatTableModule,
    MatExpansionModule, HttpClientModule
  ],
  providers: [AppConfigService, SearchService, SearchDocusignService, SearchSterlingService, FormsService, AuthGuard, appRoutingProviders],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts